<div class="d-flex flex-column border border-light">
  <button (click)="openModal()" class="btn btn-primary">
    {{ "assignments.communication.feedback" | transloco }}
  </button>
</div>
